import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { flexDirection: 'column', padding: 40, gap: 20 },
  section: { flexDirection: 'column'},

  sectionTitle: { fontSize: 13, color: "#245259", fontWeight: 'bold', marginBottom: 15 , backgroundColor: '#F0F2F3', paddingVertical: 2 },

  formWrapper: { flexDirection: 'column', gap: 15 },
  formRowWrapper: { flexDirection: 'row' },
  formContainer: { flexDirection: 'column', flex: 1, gap: 5 },
  formLabel: { fontSize: 12, color: "#5D5D5D" },
  formValue: { fontSize: 12, color: "#202020" },
});

export default function FormPDF({data}){

  return (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Activity</Text>
        <View style={styles.formRowWrapper}>
          <View style={styles.formContainer}>
            <Text style={styles.formLabel}>Post Name</Text>
            <Text style={styles.formValue}>{data?.post?.postName}</Text>
          </View>
          <View style={styles.formContainer}>
            <Text style={styles.formLabel}>Application No</Text>
            <Text style={styles.formValue}>{data?.applicationNo}</Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Customer</Text>
        <View style={styles.formWrapper}>
          <View style={styles.formRowWrapper}>
            <View style={styles.formContainer}>
              <Text style={styles.formLabel}>Full Name</Text>
              <Text style={styles.formValue}>{data?.customer?.customerName}</Text>
            </View>
            <View style={styles.formContainer}>
              <Text style={styles.formLabel}>Age</Text>
              <Text style={styles.formValue}>{data?.customer?.age}</Text>
            </View>
          </View>
          <View style={styles.formRowWrapper}>
            <View style={styles.formContainer}>
              <Text style={styles.formLabel}>Gender</Text>
              <Text style={styles.formValue}>{data?.customer?.sex}</Text>
            </View>
            <View style={styles.formContainer}>
              <Text style={styles.formLabel}>Email Address</Text>
              <Text style={styles.formValue}>{data?.customer?.emailAddress}</Text>
            </View>
          </View>
          <View style={styles.formRowWrapper}>
            <View style={styles.formContainer}>
              <Text style={styles.formLabel}>Contact Number</Text>
              <Text style={styles.formValue}>{data?.customer?.contactNumber}</Text>
            </View>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Questions & Answer</Text>
        <View style={styles.formWrapper}>
          {
          data?.formAnswers.map((item, index) => (
          <View style={styles.formRowWrapper} key={index}>
            <View style={styles.formContainer}>
              <Text style={styles.formLabel}>{item?.question}</Text>
              {item.answers.map((a, index) => (
                <React.Fragment key={index}>
                  <Text style={styles.formValue}>• {a?.answer}{a.remark && ":"}</Text>
                  {a.remark && 
                  <Text style={[styles.formValue, { marginLeft: 8 }]}>{a?.remark}</Text>
                  }
                </React.Fragment>
              ))}
            </View>
          </View>
          ))
          }
        </View>
      </View>
    </Page>
  </Document>
)
};
